import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, NavLink, useLocation } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

import friendsPng from '/img/navigation/friends.png';
import friendsWebp from '/img/navigation/friends.webp';

const FriendsLink: FC = () => {
  const { t } = useTranslation();
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const inviterId = useAppSelector((state) => state.user.user?.inviterId);
  const location = useLocation();

  const isVisible = !!matchPath(AppRoute.MAIN, location.pathname);

  return (
    isVisible &&
    ((userLevel && userLevel >= 5) || !!inviterId) && (
      <NavLink to={AppRoute.FRIENDS} className="pointer-events-auto">
        <div className="flex flex-col items-center">
          <Picture
            className="w-12 h-12 shrink-0"
            img={friendsPng}
            webp={friendsWebp}
            alt="friends"
          />
          <div className={css.friendsText}>{t('Friends')}</div>
        </div>
      </NavLink>
    )
  );
};

export { FriendsLink };
